import vendorStatusService from "../../../../services/procurementService/vendorStatusService";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { CACHE_KEY_VENDORSTATUSES } from "../../../../utils/constants";
import { VendorStatusInterface } from "../../../../models/ProcurementModule/VendorStatus";

interface AddVendorStatusContext {
  previousVendorStatuses: VendorStatusInterface[];
}

const useAddVendorStatus = (page: number, pageSize: number) => {
  const queryClient = useQueryClient();

  return useMutation<
    VendorStatusInterface,
    Error,
    VendorStatusInterface,
    AddVendorStatusContext
  >({
    mutationFn: vendorStatusService.Create,

    onMutate: () => {
      const previousVendorStatuses =
        queryClient.getQueryData<VendorStatusInterface[]>([
          CACHE_KEY_VENDORSTATUSES,
          page,
          pageSize,
        ]) || [];

      return { previousVendorStatuses };
    },

    onSuccess: (savedVendorStatus) => {
      queryClient.setQueryData<VendorStatusInterface[]>(
        [CACHE_KEY_VENDORSTATUSES, page, pageSize],
        (vendors) =>
          vendors ? [savedVendorStatus, ...vendors] : [savedVendorStatus]
      );
    },

    onError: (error, newVendorStatus, context) => {
      if (!context) return;

      queryClient.setQueryData<VendorStatusInterface[]>(
        [CACHE_KEY_VENDORSTATUSES, page, pageSize],
        context.previousVendorStatuses
      );
    },
  });
};

export default useAddVendorStatus;
